import { render, staticRenderFns } from "./SearchSkeleton2.vue?vue&type=template&id=0cc611e7"
import script from "./SearchSkeleton2.vue?vue&type=script&lang=js"
export * from "./SearchSkeleton2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports